<template>
  <div class="project">
    <p class="control">
      <a
        class="button is-small"
        @click="download_report()"
        :disabled="
          $route.name == 'therm'
            ? !project.report
            : !project.reports ||
              !project.reports.report ||
              !project.reports.report.url
        "
        style="border: 0; margin-right: 0px; margin-top: 5px"
      >
        <svg
          v-if="
            $route.name == 'therm'
              ? project.report
              : project.reports &&
                project.reports.report &&
                project.reports.report.url
          "
          viewBox="0 0 100 100"
          class="image is-32x32"
        >
          <use xlink:href="@/assets/helper_sprite.svg#download-fill" />
        </svg>
        <svg v-else viewBox="0 0 100 100" class="image is-32x32">
          <use xlink:href="@/assets/helper_sprite.svg#download" />
        </svg>
      </a>
    </p>
    <div>
      <div class="project__field field has-addons">
        <p class="control">
          <a class="button">
            <span
              v-tooltip="project.projectName"
              class="project__name is-medium-14-500-42"
              @click.exact="set_active_layer()"
              @click.ctrl="set_active_layer(true)"
              :class="{
                'has-text-info active-project has-text-weight-bold':
                  active_layer && active_layer.projectUid == project.projectUid,
              }"
              >{{ project.projectName }}</span
            >
          </a>
        </p>
        <p class="control">
          <a @click="isOpen = !isOpen" class="button card-header-icon">
            <span class="icon" style="border-radius: 8px">
              <svg v-if="!isOpen" viewBox="0 0 100 100" class="image is-24x24">
                <use xlink:href="@/assets/sprite.svg#collapse" />
              </svg>
              <svg v-else viewBox="0 0 100 100" class="image is-24x24">
                <use xlink:href="@/assets/sprite.svg#expand" />
              </svg>
            </span>
          </a>
        </p>
      </div>
      <b-collapse
        :class="{ card: isOpen }"
        :open.sync="isOpen"
        style="padding-top: 1rem"
      >
        <input
          @change="changeOpacity($event)"
          v-model="opacity"
          class="slider is-circle"
          step="1"
          min="0"
          max="100"
          value="100"
          type="range"
        />
        <!-- <footer class="card-footer"><a class="card-footer-item">Save</a><a class="card-footer-item">Edit</a><a class="card-footer-item">Delete</a></footer>-->
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import APIService from "@/services/api.service";

export default {
  props: ["project"],
  data() {
    return {
      apiService: new APIService(),
      layer_meta: null,
      isOpen: false,
      isActive: false,
      opacity: 100,
    };
  },
  methods: {
    download_report() {
      if (this.project.report)
        this.apiService
          .get_report_download_link({ url: this.project.report })
          .then((res) => {
            window.open(res.data, "_blank");
          })
          .catch((res) => {
            console.log("err");
          });
    },
    async set_active_layer(is_ctrl = false) {
      this.$snackbar.open({
        message: "You are about to switch to new layer. Are you sure?",
        type: "is-warning",
        position: "is-top",
        actionText: "SURE",
        indefinite: true,
        onAction: () => {
          this.$store.dispatch("set_active_layer", {
            layer: this.project,
            is_ctrl,
            opacity: this.opacity,
          });
          this.isActive = true;
        },
      });
    },
    changeOpacity() {
      if (this.isActive) {
        this.map.setPaintProperty(
          "MAPLAYER:" + String(this.project.projectUid),
          "raster-opacity",
          parseInt(this.opacity, 10) / 100
        );
      }
    },
  },
  computed: {
    ...mapGetters(["map", "draw", "active_layer", "features"]),
  },
  watch: {
    draw: {
      handler(val) {
        if (this.map)
          this.map.on("style.load", () => {
            if (this.isActive) {
              this.$store.dispatch("set_active_layer", {
                layer: this.project,
                is_ctrl: true,
                opacity: this.opacity,
              });
            }
          });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.flyto-btn {
  cursor: pointer;
  margin-left: 10px;
}
.card {
  border: none;
  box-shadow: none;
}
.project__btns {
  display: flex;
  justify-content: flex-start;
}
.project {
  display: flex;
  width: 100%;
  text-align: center;
  transition: all 0.2s;
  font-weight: 300;
  &__btns {
    margin-bottom: 0;
    .column {
      padding: 0;
    }
  }
  &__field.has-addons {
    margin: 0;

    display: flex;
    justify-content: flex-start;
    padding: 0;
  }

  .field .control {
    margin-bottom: 0;
  }
  label {
    padding: 0;
  }
  .card-content {
    padding: 0 3px;
  }
  &__name {
    &.active_cluster {
      color: blue;
    }
    opacity: 0.8;

    &.active-project {
      opacity: 1;
    }
    // font-size: 15px;
    width: 150px;
    text-align: left;
    overflow: hidden;
  }
}
.slider {
  width: 100%;
  margin-bottom: 1rem;
  padding-top: 0rem;
  margin-top: 0;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  cursor: pointer; /* Cursor on hover */
  width: 18px;
  height: 18px;
  box-shadow: 0 3px 6px 0 rgba(139, 147, 169, 0.5);
  border: solid 2px #8d95aa;
  background-color: #ffffff;
  margin-top: -6px;
}
</style>


